import React, { Component } from "react";

import LoadingPage from "./pages/LoadingPage";

const PRERENDER_ID = 'root-prerendered';

const getPrerenderEle = () =>
  document.getElementById(PRERENDER_ID);

export const removePrerender = () => {
  const prerenderEle = getPrerenderEle();
  if (prerenderEle) {
    prerenderEle.parentNode.removeChild(prerenderEle);
  }
}

export default function asyncComponent(importComponent) {
  class AsyncComponent extends Component {
    constructor(props) {
      super(props);

      this.state = {
        component: null,
      };
    }

    async componentDidMount() {
      const { default: component } = await importComponent();

      this.setState({
        component: component,
      });
    }

    componentWillUnmount() {
      removePrerender();
    }

    componentDidUpdate()
    {
      if (this.state.component) {
        removePrerender();
        const hashId = ((window.location.hash||'')+'').slice(1);
        if (hashId && hashId.indexOf('=') < 0) {
          const ele =
            window.document.getElementById(hashId) ||
            window.document.body.querySelector("a[name=" + hashId + "]");

          if (ele) {
            ele.scrollIntoView();
            return;
          }
        }
      }
    }

    render() {
      const Component = this.state.component;
      return Component ? <Component {...this.props} /> : (getPrerenderEle() ? null : <LoadingPage />);
    }
  }

  return AsyncComponent;
}
